/* generated by pull.js */
const manifest = {
    editorOnly: true,
    name: 'Variable manager',
    description: 'Enhanced variable and list manager with improved accessibility, modern UI design, better search capabilities, responsive positioning, and optimized performance for managing project variables.',
    credits: [
        {
            name: 'Jeffalo'
        },
        {
            name: 'GarboMuffin'
        }
    ],
    userscripts: [
        {
            url: 'userscript.js'
        }
    ],
    userstyles: [
        {
            url: 'style.css'
        }
    ],
    dynamicDisable: true,
    tags: ['editor', 'recommended'],
    enabledByDefault: true
};
export default manifest;
